<template>
  <div class="review-end flex-col">
    <a-input-search
      style="width: 300px"
      placeholder="请输入投标单位名称"
      enter-button
      @search="searchBidderInEnd"
    />
    <el-scrollbar class="m-t-16 scrollbar-y-hidden">
      <el-table id="endTable" border :data="list" size="medium">
        <el-table-column
          label="投标单位"
          align="center"
          prop="supplierName"
          fixed
        />
        <el-table-column
          :label="`报价总金额(${offerUnit})`"
          prop="offerPrice"
          align="center"
          show-tooltip-when-overflow
        />
        <template v-if="isDefaultModel">
          <el-table-column
            v-for="item in reviewWayList"
            :key="item.wayType"
            :label="inquiryReviewTypeDict.translate(item.wayType).label"
            align="center"
            show-tooltip-when-overflow
          >
            <template slot-scope="{ row }">
              <span>{{ findScore(item, row) }}</span>
            </template>
          </el-table-column>
        </template>
        <el-table-column label="评审总分" align="center" prop="summarySore" />
        <el-table-column label="排序" align="center" prop="rankNum" />
        <el-table-column
          v-if="!reviewClosed"
          label="操作"
          align="center"
          prop="rankNum"
        >
          <template slot-scope="{ $index }">
            <el-button
              :disabled="$index === 0"
              type="text"
              @click="upItem($index)"
            >
              上移
            </el-button>
            <el-button
              :disabled="!showDownItem($index)"
              type="text"
              @click="downItem($index)"
            >
              下移
            </el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-scrollbar>

    <div v-if="showEndAction" class="end-action">
      <el-button v-if="showRestartReview" type="primary" @click="reStartReview">
        开启项目重评
      </el-button>
      <el-button v-else type="primary" @click="endReview">
        排序无误，评标结束
      </el-button>
    </div>
  </div>
</template>

<script>
import {
  inquiryReviewTypeDict,
  onlineReviewMethodDict,
  onlineReviewScoreStatusDict
} from '@/dictionary/project/online-review'
import { getInquiryReviewRankPageApi } from '@/api/procure/inquiry-review'
import { getNegotiationReviewRankPageApi } from '@/api/procure/negotiation-review'
import {
  completePurchaseReviewApi,
  reStartPurchaseReviewApi
} from '@/api/procure/purchase-review'
import { arrToObj, moveInArray } from '@/utils/utils'
import { inquiryReviewModelDict } from '@/dictionary/project/inquiry'
import { purchaseTypeDict } from '@/dictionary/project/common'

export default {
  name: 'OnlineReviewEnd',

  props: {
    reviewId: {
      type: [String, Number],
      default: ''
    },

    orderId: {
      type: [String, Number],
      default: ''
    },

    reviewList: {
      type: Array,
      default: () => []
    },

    reviewClosed: {
      type: Boolean,
      default: false
    },

    offerUnit: {
      type: String,
      default: '元'
    },

    reviewModel: {
      type: Number,
      default: inquiryReviewModelDict.SYNTHESIS.value
    },

    summaryList: {
      type: Array,
      default: () => []
    },

    beforeCandidate: {
      type: Boolean,
      default: false
    },

    purchaseType: {
      type: [Number, String],
      default: purchaseTypeDict.INQUIRY.value
    }
  },

  data() {
    return {
      onlineReviewMethodDict,
      inquiryReviewTypeDict,

      list: [],
      page: 1,
      size: 10,
      total: 0
    }
  },

  computed: {
    reviewWayList() {
      // 初步评审不在综合排序表中显示
      return this.reviewList.filter(
        item => item.wayType !== inquiryReviewTypeDict.QUALIFICATION.value
      )
    },

    // 是否是综合评分法（默认）
    isDefaultModel() {
      return this.reviewModel === inquiryReviewModelDict.SYNTHESIS.value
    },

    showEndAction() {
      // 当全部评审办法都已汇总时显示
      return this.summaryList.every(
        item =>
          item.summaryStatus === onlineReviewScoreStatusDict.COMPLETED.value
      )
    },

    showRestartReview() {
      return this.reviewClosed && this.beforeCandidate
    }
  },

  created() {
    this.searchBidderInEnd()
  },

  methods: {
    /**
     * 在确认评标结束中，搜索投标单位
     */
    searchBidderInEnd(value) {
      const params = {
        orderId: this.orderId,
        supplierName: value,
        isListing: 1
      }
      const objApi = {
        [purchaseTypeDict.INQUIRY.value]: getInquiryReviewRankPageApi,
        [purchaseTypeDict.NEGOTIATION.value]: getNegotiationReviewRankPageApi
      }
      objApi[this.purchaseType](this.reviewId, params)
        .then(res => {
          this.list = (res.data?.records || []).sort((x, y) => {
            return x.rankNum - y.rankNum
          })
          this.total = res.data?.total || 0
        })
        .catch(err => {
          if (err?.message) this.$message.error(err.message)
        })
    },

    findScore(reviewWay, row) {
      const summaryItemsMap = arrToObj(JSON.parse(row.summaryItems), 'wayId')
      const score = summaryItemsMap[reviewWay.wayId]?.score
      if (reviewWay.reviewMethod === onlineReviewMethodDict.PASS.value) {
        return '通过'
      }
      return score || '-'
    },

    /**
     * 重新评审
     */
    reStartReview() {
      this.$confirm('是否重新进行评审', '系统提示', {
        type: 'warning'
      })
        .then(() => {
          reStartPurchaseReviewApi(this.reviewId)
            .then(res => {
              this.$emit('afterReStart')
            })
            .catch(err => {
              if (err?.message) this.$message.error(err.message)
            })
        })
        .catch()
    },

    /**
     * 结束评审
     */
    endReview() {
      const postData = this.list.map((item, index) => {
        return {
          supplierId: item.supplierId,
          rankNum: index + 1
        }
      })
      completePurchaseReviewApi(this.reviewId, postData)
        .then(res => {
          // 结束评审后跳转评标报告页面生成评标报告
          const reviewHallRouteName = this.$route.name
          const reviewHallRouteParams = this.$route.params
          this.$router.replace({
            name: reviewHallRouteName.replace(/Hall/g, 'Report'),
            params: reviewHallRouteParams,
            query: {
              purchaseType: this.purchaseType
            }
          })
        })
        .catch(err => {
          if (err?.message) this.$message.error(err.message)
        })
    },

    /**
     * 上移
     */
    upItem(index) {
      moveInArray(this.list, index, index - 1)
      this.list.forEach((item, index) => {
        item.rankNum = index + 1
      })
    },

    showDownItem(index) {
      if (this.list.length === 1) {
        return false
      }
      return index !== this.list.length - 1
    },

    /**
     * 下移
     */
    downItem(index) {
      moveInArray(this.list, index, index + 1)
      this.list.forEach((item, index) => {
        item.rankNum = index + 1
      })
    }
  }
}
</script>

<style scoped lang="scss">
.review-end {
  width: 100%;
  background: $white-color;
  height: 100%;
  min-height: 600px;
  padding: 24px;
}

.end-action {
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  background: $white-color;
  box-shadow: 0px -3px 6px rgba(0, 0, 0, 0.06);
  border: 1px solid $info-fifth-color;
  height: 56px;
  text-align: center;
  padding: 12px 0;
  z-index: 9999;
}
</style>
